import { __read, __spread } from "tslib";
import produce from 'immer';
import has from 'lodash/has';
import clamp from 'lodash/clamp';
import { isFillable, isStrokable } from './shared';
import { MatrixUtils } from '../math';
import DATA_KEY from '../constants/dataKey';
// Re-export utils under the items namespace
export * from './shared/utils';
export function getChildIds(item) {
    return item.children;
}
export function getMatrix(item) {
    return item.itemProps.matrix;
}
export function getData(item) {
    return item.itemProps.data;
}
export function getClientData(item) {
    var _a;
    return (_a = getData(item)[DATA_KEY]) !== null && _a !== void 0 ? _a : {};
}
export function isAspectRatioLocked(item) {
    return getClientData(item).isAspectRatioLocked;
}
export function getName(item) {
    return item.itemProps.name;
}
export function getId(item) {
    return item.id;
}
export function getClassName(item) {
    return item.className;
}
export function getFills(item) {
    return isFillable(item) ? item.fillStyle.fills : [];
}
export function getStrokes(item) {
    return isStrokable(item) ? item.strokes : [];
}
export function getShapeType(item) {
    return item.type;
}
/**
 * Returns the cached local bounding box of the item
 */
export function getFrame(item) {
    var _a, _b;
    return (_b = (_a = getClientData(item)) === null || _a === void 0 ? void 0 : _a.frame) !== null && _b !== void 0 ? _b : null;
}
export function mSetData(item, key, value) {
    var data = getData(item);
    if (!has(data, DATA_KEY)) {
        data[DATA_KEY] = {};
    }
    data[DATA_KEY][key] = value;
    return item;
}
export var setData = produce(mSetData);
export function mSetFrame(item, frame) {
    return mSetData(item, 'frame', frame);
}
export var setFrame = produce(mSetFrame);
export function mSetName(item, name) {
    // eslint-disable-next-line no-param-reassign
    item.itemProps.name = name;
    return item;
}
export var setName = produce(mSetName);
export function mAddFills(item, fills) {
    var _a;
    (_a = item.fillStyle.fills).push.apply(_a, __spread(fills));
    return item;
}
export var addFills = produce(mAddFills);
export function mClearFills(item) {
    // eslint-disable-next-line no-param-reassign
    item.fillStyle.fills = [];
    return item;
}
export var clearFills = produce(mClearFills);
export function mAddStrokes(mutable, strokes) {
    var _a;
    (_a = mutable.strokes).push.apply(_a, __spread(strokes));
    return mutable;
}
export var addStrokes = produce(mAddStrokes);
export function mClearStrokes(mutable) {
    mutable.strokes = [];
    return mutable;
}
export var clearStrokes = produce(mClearStrokes);
export function mTranslate(mutable, point) {
    MatrixUtils.translate(mutable.itemProps.matrix, point, mutable.itemProps.matrix);
    return mutable;
}
export var translate = produce(mTranslate);
export function mTransform(mutable, matrix) {
    var newMatrix = MatrixUtils.multiply(matrix, getMatrix(mutable));
    mutable.itemProps.matrix = newMatrix;
    return mutable;
}
export var transform = produce(mTransform);
export function mSetOpacity(mutable, opacity) {
    mutable.itemProps.opacity = clamp(opacity, 0, 1);
    return mutable;
}
export var setOpacity = produce(mSetOpacity);
